function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-000860f5\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../../vue-loader/lib/selector?type=styles&index=0!./tree.vue")
}
var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./tree.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-000860f5\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./tree.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-jstree/src/tree.vue
// module id = 11
// module chunks = 0